import axios, {AxiosRequestConfig} from "axios";
import i18n from "../translations/i18n";

const instance = axios.create({
  validateStatus: (status) => status < 500,
});

instance.interceptors.request.use(async (config: AxiosRequestConfig) => {
  if (config && config.headers) {
    config.headers['Accept-Language'] = i18n.language;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default instance;